import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, Tab, Tabs } from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { togglePolling } from "src/polling/actions";
import {
  saveUserPreferences,
  SaveUserPreferencesActionType
} from "src/preferences/actions";
import { UserPreferences } from "src/preferences/reducer";
import { showAlertBanner } from "src/shared/alertBanner/actions";
import QuiqButton from "src/shared/QuiqButton";
import selectorsToProps from "src/utils/selectorsToProps";
import closeIcon from "./close.svg";
import "./Preferences.scss";
import { getClientConfig, getUserPreferences } from "./selector";

interface PreferencesState {
  open: boolean;
  anchorEl: HTMLElement | null;
  activeTab: number;
  language: string | null;
}

interface PreferenceProps {
  userPreferences: UserPreferences;
  saveUserPreferences: SaveUserPreferencesActionType;
  togglePollingFunc: typeof togglePolling;
  showAlertBannerFunc: typeof showAlertBanner;
  clientConfig: any;
}
export class Preferences extends React.Component<
  PreferenceProps,
  PreferencesState
> {
  constructor(props: PreferenceProps) {
    super(props);

    this.state = { open: false, anchorEl: null, activeTab: 0, language: null };
  }

  public openModal = (event: React.MouseEvent<HTMLElement>) => {
    this.props.togglePollingFunc(false);

    this.setState({
      open: this.state.open ? false : true,
      anchorEl: event.currentTarget
    });
  };

  public closeModal = (event?: React.MouseEvent<HTMLElement>) => {
    this.props.togglePollingFunc(true);
    this.setState({ open: false, anchorEl: null });
  };

  public stopPropagation = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };
  public handleTabChange = (event: object, newValue: number) => {
    this.setState({ activeTab: newValue });
  };

  public render() {
    const supportedLanguages = this.props.userPreferences.supportedLanguages;

    return (
      <QuiqButton
        className="Menu__link__preferences"
        onClick={this.openModal}
        variant="text"
      >
        <FontAwesomeIcon
          icon={faCog}
          className="Menu__link__preferences-icon"
        />
        <Dialog
          open={this.state.open}
          // onEnter={this.closeModal}
          // onClose={this.closeModal}
          PaperProps={{ className: "PreferencesModal={true}" }}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          onBackdropClick={this.closeModal as any}
          onClick={this.stopPropagation}
          transitionDuration={0}
        >
          <div className="PreferencesModal__header-container">
            <Tabs
              className="Preferences__tabs"
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              classes={{ indicator: "Preferences__tabs__indicator" }}
            >
              <Tab
                className="Preferences__tabs__tab"
                label="Preferences"
                classes={{
                  labelContainer: "Preferences__tabs__tab__label",
                  selected: "Preferences__tabs__tab--selected"
                }}
                disableRipple={true}
              />
            </Tabs>
            <div
              className="PreferencesModal__close-icon-container"
              onClick={this.closeModal}
            >
              <img src={closeIcon} className="PreferencesModal__close-icon" />
            </div>
          </div>
          <div className="PreferencesModal__content">
            <div
              className={"PreferencesModal__content-dropdown-item-container"}
            >
              <div className="PreferencesModal__content-dropdown-item-container-label">
                <label>Language:</label>
              </div>
              <div>
                <Select
                  className={"select"}
                  defaultValue={this.defaultValue()}
                  options={this.optionsFor(supportedLanguages)}
                  onChange={this.handleInputChange as any}
                  isSearchable={false}
                />
              </div>
            </div>
            <div className="PreferencesModal__save-buttons-container">
              <QuiqButton
                className="PreferencesModal__save-button"
                variant="text"
                onClick={this.updatePreferences}
              >
                Save
              </QuiqButton>
              <QuiqButton
                className="PreferencesModal__cancel-button"
                variant="text"
                onClick={this.closeModal}
              >
                Cancel
              </QuiqButton>
            </div>
          </div>
        </Dialog>
      </QuiqButton>
    );
  }

  private handleInputChange = (value: { value: string; label: string }) => {
    this.setState({ language: value.value });
  };

  private updatePreferences = () => {
    this.props.saveUserPreferences({ language: this.state.language });

    this.closeModal();
  };

  private optionsFor = (values?: any[]) => {
    return (
      values &&
      values.map(value => {
        return {
          value,
          label: (value || "").replace(/^\w/, c => c.toUpperCase())
        };
      })
    );
  };

  private defaultValue = () => {
    const value = this.props.userPreferences.language;

    return {
      value,
      label: (value || "").replace(/^\w/, c => c.toUpperCase())
    };
  };
}

export default connect(
  selectorsToProps({
    userPreferences: getUserPreferences,
    clientConfig: getClientConfig
  }),
  {
    saveUserPreferences: saveUserPreferences.action,
    togglePollingFunc: togglePolling,
    showAlertBannerFunc: showAlertBanner
  }
)(Preferences);



// WEBPACK FOOTER //
// ./src/topNav/Preferences.tsx